<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { Input } from "sveltestrap";
    import l from "./utils/locale";
    import { _log } from "./utils/logger";
    import { getMaxValue, getStepValue } from "./utils/util";

    const dispatch = createEventDispatcher();
    export let name = "";
    export let _filters = {};
    let valueEffectName = "";
    let value = 0;

    const getFilterEffectName = () => {
        let r = ""
        switch(value) {
            case "1": r = "saturated"; break;
            case "2": r = "blue"; break;
            case "3": r = "silver"; break;
            case "4": r = "neon"; break;
            case "5": r = "emboss"; break;
            case "6": r = "cartoon"; break;
            case "7": r = "blured"; break;
            case "8": r = "black"; break;
            case "9": r = "ripple"; break;
            case "10": r = "sepia"; break;
            case "11": r = "noise"; break;
            case "12": r = "vignette"; break;
            case "13": r = "gray"; break;
            default: r = ""
        }
        _log("getFilterEffectName", r)
        _log("getFilterEffectName", value)
        valueEffectName = r
        return r
    };

    onMount(() => {
        _log("name", name);
        if (_filters[name]) {
            value = _filters[name];
            dispatch("change", { name, value });
        }
    });

    const onChangeFilter = (e) => {
        value = e.target.value;
        if (name === "effect"){
            setTimeout(() => {
                
                getFilterEffectName()
            }, 110);
        } 
        dispatch("change", { name, value: e.target.value });
    };
    
</script>

<div class="app-filter">
    <div
        style={`color:${value > 0 ? "var(--main-color)" : ""}`}
        class="app-filter-label noselect"
    >
    {l[name]}
    {#if (name === "effect" || name === "эффект") && value > 0}
        {value > 0 ? ` (${valueEffectName})` : ""}
    {:else}
        {value > 0 ? ` (${value})` : ""}
    {/if}
</div>
<Input
    class="app-filter-range"
    on:input={onChangeFilter}
    {value}
    min={0}
    max={getMaxValue(name)}
    step={getStepValue(name)}
    {name}
    type="range"
 />
</div>
